import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { FC } from 'react';

interface IInviteCountCaptionProps {
  /** Total number of invites already sent to professionals for the shift. */
  count: number;
}

/**
 * Caption shown below the "Invite" button on the open-shift details page,
 * giving offices visibility into how many invites they have already sent.
 * Shows "{count} invited" when at least one invite was sent, otherwise
 * "None invited yet".
 */
export const InviteCountCaption: FC<IInviteCountCaptionProps> = ({ count }) => (
  <Typography variant="body2" italic textAlign="center" color={colors.neutral[500]}>
    {count > 0 ? `${count} invited` : 'None invited yet'}
  </Typography>
);
